import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { configBonusHandle } from '@/api/apis';
import json from 'vue-resource/src/http/interceptor/json';
export default {
  props: {
    bonusData: {
      required: true
    }
  },
  data: function data() {
    return {
      conditions: {
        bonus: 0.1
      }
    };
  },
  watch: {
    bonusData: function bonusData(newVal, oldVal) {
      this.conditions = JSON.parse(newVal.conditions);
    },
    deep: true,
    // 如果 bonusData 是对象或数组，需要这个
    immediate: false // 是否在初始时立即触发一次

  },
  mounted: function mounted() {},
  methods: {
    handleInput: function handleInput(value) {
      // 只允许数字和最多两位小数
      var formattedValue = value.replace(/[^0-9.]/g, '') // 只保留数字和点
      .replace(/^(\d*\.?\d{0,2}).*$/, '$1'); // 限制两位小数

      this.conditions.bonus = formattedValue;
    },
    clickSave: function clickSave() {
      var _this = this;

      configBonusHandle({
        id: this.bonusData.id,
        conditions: JSON.stringify(this.conditions)
      }).then(function _callee(res) {
        return regeneratorRuntime.async(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$alert('保存成功', '提示', {
                  confirmButtonText: '确定'
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        });
      });
    }
  }
};